import * as e from "react";
const s = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("mask", { id: "text-cursors_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z" })),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10z",
      stroke: "#2d6ded",
      strokeWidth: 4,
      mask: "url(#text-cursors_svg__a)"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "text-cursors_svg__b", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M15 6a3.99 3.99 0 00-3 1.35C11.27 6.52 10.2 6 9 6a1 1 0 000 2 2 2 0 012 2v4a2 2 0 01-2 2 1 1 0 100 2 3.99 3.99 0 003-1.35c.73.83 1.8 1.35 3 1.35a1 1 0 100-2c-1.1 0-2-.9-2-2v-4a2 2 0 012-2 1 1 0 100-2z" })),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15 6a3.99 3.99 0 00-3 1.35C11.27 6.52 10.2 6 9 6a1 1 0 000 2 2 2 0 012 2v4a2 2 0 01-2 2 1 1 0 100 2 3.99 3.99 0 003-1.35c.73.83 1.8 1.35 3 1.35a1 1 0 100-2c-1.1 0-2-.9-2-2v-4a2 2 0 012-2 1 1 0 100-2z",
      stroke: "#2d6ded",
      strokeWidth: 4,
      mask: "url(#text-cursors_svg__b)"
    }
  )
), a = s;
export {
  a as default
};
